<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" label-width="140px">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="GRI编码" prop="fiveBitCode">
                    <el-input v-model.trim="queryCondition.fiveBitCode" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="GRI名称" prop="fiveBitCodeName">
                    <el-input v-model.trim="queryCondition.fiveBitCodeName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Category1" prop="categoryLevel1Id">
                    <el-select v-model="queryCondition.categoryLevel1Id" clearable @change="changeCategory1()" style="width:100%">
                      <el-option :key="index" v-for="(item,index) in categoryList1" :label="item.name" :value="item.tmCategoryId"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Category2" prop="categoryLevel2Id">
                    <el-select v-model="queryCondition.categoryLevel2Id" clearable @change="changeCategory2()" style="width:100%">
                      <el-option :key="index" v-for="(item,index) in categoryList2" :label="item.name" :value="item.tmCategoryId"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="Category3" prop="categoryLevel3Id">
                      <el-select v-model="queryCondition.categoryLevel3Id" clearable style="width:100%">
                        <el-option :key="index" v-for="(item,index) in categoryList3" :label="item.name" :value="item.tmCategoryId"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button @click="queryData" type="primary">{{$t('common.search')}}</el-button>
            <el-button @click="restQueryForm" type="primary">{{$t('common.reset')}}</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <div style="margin-top:10px">
        <el-row style="margin-bottom: 10px;">
          <el-button type="primary" @click="confirmMethod">{{ $t('common.confirm') }}</el-button>
          <el-button @click="onCancel">{{ $t('common.cancel') }}</el-button>
        </el-row>
        <el-table :data="tableList" row-key="tmFiveBitCodeId" ref="tableList" @selection-change="selectionChange" border highlight-current-row max-height="300">
<!--          <el-table-column align="center" width="56" label="选择">
            <template slot-scope="scope">
              <el-radio v-model="radioVal" :label="scope.row.tmFiveBitCodeId">&nbsp;</el-radio>
            </template>
          </el-table-column>-->
          <el-table-column type="selection"></el-table-column>
          <el-table-column show-overflow-tooltip prop="fiveBitCode" label="GRI code" min-width="120"></el-table-column>
          <el-table-column show-overflow-tooltip prop="fiveBitCodeName" label="GRI 名称" min-width="140"></el-table-column>
          <el-table-column show-overflow-tooltip prop="categoryLevel1Name" label="Category1" min-width="140"></el-table-column>
          <el-table-column show-overflow-tooltip prop="categoryLevel2Name" label="Category2" min-width="140"></el-table-column>
          <el-table-column show-overflow-tooltip prop="categoryLevel3Name" label="Category3" min-width="140"></el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IcSelect from "@/components/common/icSelect";
import { apiService } from "@/api/material/material-master-data";
export default {
  components: {
    IcSelect
  },
  props: {

  },
  data() {
    return {
      queryCondition: {
        pageNum: 1,
        pageSize: 15,
        fiveBitCode: null,
        fiveBitCodeName: null,
        categoryLevel1Id: null,
        categoryLevel2Id: null,
        categoryLevel3Id: null,
        isConventionalMaterials: false,
        isOpenDisable: false,
        materialType: null,
      },
      tableList: [],
      totalCount: 0,
      radioVal: null,
      categoryList1: [],
      categoryList2: [],
      categoryList3: [],
      isShow: false,//控制查询列表收缩展开

      multipleSelection: [],
    };
  },
  watch: {

  },
  created() {
    this.queryData()
    this.getCategoryList(1)
  },
  methods: {
    queryData() {
      apiService.findGriList(this.queryCondition).then((res) => {
        console.log("🚀 ~ queryData ~ res:", res)
        this.tableList = res.resultData;
        this.totalCount = res.totalCount;
      });
    },
    getCategoryList() {
      apiService.findCategory({ categoryLevel: 1 }).then((res) => {
        res.data = res.data.map(item => ({
          ...item,
          name: item.name || ' '
        }))
        this.categoryList1 = res.data;
      });
    },
    //根据选中Category1查询Category2
    changeCategory1() {
      this.queryCondition.categoryLevel2Id = null
      this.queryCondition.categoryLevel3Id = null
      this.categoryList2 = []
      this.categoryList3 = []
      apiService.findCategory({ categoryLevel: 2, pid: this.queryCondition.categoryLevel1Id }).then((res) => {
        res.data = res.data.map(item => ({
          ...item,
          name: item.name || ' '
        }))
        this.categoryList2 = res.data;
      });
    },
    //根据选中Category2查询Category3
    changeCategory2() {
      this.queryCondition.categoryLevel3Code = null
      this.categoryList3 = []
      apiService.findCategory({ categoryLevel: 3, pid: this.queryCondition.categoryLevel2Id }).then((res) => {
        res.data = res.data.map(item => ({
          ...item,
          name: item.name || ' '
        }))
        this.categoryList3 = res.data;
      });
    },
    // 确认选中
    confirmMethod() {
      // console.log("🚀 ~ confirmMethod ~ this.radioVal:", this.radioVal)
      // if (this.radioVal) {
      //   const changeRow = this.tableList.filter(item => item.tmFiveBitCodeId === this.radioVal)
      //   this.$emit('onConfirmGri', changeRow)
      //   this.radioVal = null
      // } else {
      //   this.$message({
      //     type: "error",
      //     message: this.$t("common.pleaseSelectData")
      //   });
      // }
      if(this.multipleSelection.length > 0) {
        this.$emit('onConfirmGri', this.multipleSelection);
      } else {
          this.$message({
            type: "error",
            message: this.$t("common.pleaseSelectData")
          });
      }
    },
    onCancel() {
      this.restQueryForm()
      this.$emit('onCloseGri')
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
    //查询条件重置方法
    restQueryForm() {
      this.$refs.queryCondition.resetFields();
      this.queryCondition.pageSize = 15;
      this.queryCondition.pageNum = 1;
      this.categoryList2 = []
      this.categoryList3 = []
    },
    selectionChange(val) {
      this.multipleSelection = val;
    }
  }
};
</script>

<style scoped lang="scss"></style>
